module.exports = __webpack_public_path__ + "img/loader.e1818eba.png";